<template>
    <b-overlay :show="busy" rounded="sm">
        <!-- {{ search }}<br /><br />
        {{ item }} -->
        <b-card class="standardpage reports invoices border-none">
            <div class="availtable datatable text-left">
                <b-card-body class="py-0">
                    <b-tabs class="gridtabs">
                        <b-tab :active="true">
                            <template #title>
                                <div class="badgecontainer pr-5">
                                    <i :class="options.icon" class="text-primary mr-1"></i>
                                    <span class="text-center badgenormal badge-secondary badge-pill">
                                        {{ item.code }}
                                    </span>
                                    <span class="text-warning">&lt;{{ selection.length == 0 ? "new" : "edit"
                                        }}&gt;</span>
                                </div>
                            </template>
                            <p class="py-3 px-0">
                                <b-row>


                                    <b-col cols="12" sm="6" md="4" xl="3">
                                        <b-form-group label="Code" label-for="ident" label-cols="12">
                                            <b-input-group>
                                                <b-form-input type="text" v-model="item.ident" placeholder="Enter code"
                                                    size="sm" trim></b-form-input>
                                                <b-input-group-append>
                                                    <b-button size="sm" variant="outline-secondary"
                                                        @click="item.ident = ''">
                                                        <i class="fa fa-remove"></i>
                                                    </b-button>
                                                </b-input-group-append>
                                            </b-input-group>
                                        </b-form-group>
                                    </b-col>
                                    <b-col cols="12" sm="6" md="4" xl="3">
                                        <b-form-group label="Name" label-for="name" label-cols="12">
                                            <b-input-group>
                                                <b-form-input type="text" v-model="item.name" placeholder="Enter name"
                                                    size="sm"></b-form-input>
                                                <b-input-group-append>
                                                    <b-button size="sm" variant="outline-secondary"
                                                        @click="item.name = ''">
                                                        <i class="fa fa-remove"></i>
                                                    </b-button>
                                                </b-input-group-append>
                                            </b-input-group>
                                        </b-form-group>
                                    </b-col>
                                    <b-col cols="12" sm="6" md="4" xl="3">
                                        <b-form-group label="Type" label-for="type" label-cols="12">
                                            <b-input-group>
                                                <b-form-input type="text" v-model="item.type" placeholder="Enter type"
                                                    size="sm"></b-form-input>
                                                <b-input-group-append>
                                                    <b-button size="sm" variant="outline-secondary"
                                                        @click="item.type = ''">
                                                        <i class="fa fa-remove"></i>
                                                    </b-button>
                                                </b-input-group-append>
                                            </b-input-group>
                                        </b-form-group>
                                    </b-col>
                                    <b-col cols="12" sm="6" md="4" xl="3">
                                        <b-form-group label="Latitude" label-for="latitude_deg" label-cols="12">
                                            <b-input-group>
                                                <b-form-input type="text" v-model="item.latitude_deg"
                                                    placeholder="Enter latitude" size="sm"></b-form-input>
                                                <b-input-group-append>
                                                    <b-button size="sm" variant="outline-secondary"
                                                        @click="item.latitude_deg = ''">
                                                        <i class="fa fa-remove"></i>
                                                    </b-button>
                                                </b-input-group-append>
                                            </b-input-group>
                                        </b-form-group>
                                    </b-col>
                                    <b-col cols="12" sm="6" md="4" xl="3">
                                        <b-form-group label="Longitude" label-for="longitude_deg" label-cols="12">
                                            <b-input-group>
                                                <b-form-input type="text" v-model="item.longitude_deg"
                                                    placeholder="Enter longitude" size="sm"></b-form-input>
                                                <b-input-group-append>
                                                    <b-button size="sm" variant="outline-secondary"
                                                        @click="item.longitude_deg = ''">
                                                        <i class="fa fa-remove"></i>
                                                    </b-button>
                                                </b-input-group-append>
                                            </b-input-group>
                                        </b-form-group>
                                    </b-col>
                                    <b-col cols="12" sm="6" md="4" xl="3">
                                        <b-form-group label="Elevation" label-for="elevation_ft" label-cols="12">
                                            <b-input-group>
                                                <b-form-input type="text" v-model="item.elevation_ft"
                                                    placeholder="Enter elevation" size="sm"></b-form-input>
                                                <b-input-group-append>
                                                    <b-button size="sm" variant="outline-secondary"
                                                        @click="item.elevation = ''">
                                                        <i class="fa fa-remove"></i>
                                                    </b-button>
                                                </b-input-group-append>
                                            </b-input-group>
                                        </b-form-group>
                                    </b-col>
                                    <b-col cols="12" sm="6" md="4" xl="3">
                                        <b-form-group label="Continent" label-for="continent" label-cols="12">
                                            <b-input-group>
                                                <b-form-input type="text" v-model="item.continent"
                                                    placeholder="Enter continent" size="sm"></b-form-input>
                                                <b-input-group-append>
                                                    <b-button size="sm" variant="outline-secondary"
                                                        @click="item.continent = ''">
                                                        <i class="fa fa-remove"></i>
                                                    </b-button>
                                                </b-input-group-append>
                                            </b-input-group>
                                        </b-form-group>
                                    </b-col>
                                    <b-col cols="12" sm="6" md="4" xl="3">
                                        <b-form-group label="Country Code" label-for="iso_country" label-cols="12">
                                            <b-input-group>
                                                <b-form-input type="text" v-model="item.iso_country"
                                                    placeholder="Enter country code" size="sm"></b-form-input>
                                                <b-input-group-append>
                                                    <b-button size="sm" variant="outline-secondary"
                                                        @click="item.iso_country = ''">
                                                        <i class="fa fa-remove"></i>
                                                    </b-button>
                                                </b-input-group-append>
                                            </b-input-group>
                                        </b-form-group>
                                    </b-col>
                                    <b-col cols="12" sm="6" md="4" xl="3">
                                        <b-form-group label="Region Code" label-for="iso_region" label-cols="12">
                                            <b-input-group>
                                                <b-form-input type="text" v-model="item.iso_region"
                                                    placeholder="Enter region code" size="sm"></b-form-input>
                                                <b-input-group-append>
                                                    <b-button size="sm" variant="outline-secondary"
                                                        @click="item.iso_region = ''">
                                                        <i class="fa fa-remove"></i>
                                                    </b-button>
                                                </b-input-group-append>
                                            </b-input-group>
                                        </b-form-group>
                                    </b-col>
                                    <b-col cols="12" sm="6" md="4" xl="3">
                                        <b-form-group label="Municipality" label-for="municipality" label-cols="12">
                                            <b-input-group>
                                                <b-form-input type="text" v-model="item.municipality"
                                                    placeholder="Enter municipality" size="sm"></b-form-input>
                                                <b-input-group-append>
                                                    <b-button size="sm" variant="outline-secondary"
                                                        @click="item.municipality = ''">
                                                        <i class="fa fa-remove"></i>
                                                    </b-button>
                                                </b-input-group-append>
                                            </b-input-group>
                                        </b-form-group>
                                    </b-col>
                                    <b-col cols="12" sm="6" md="4" xl="3">
                                        <b-form-group label="Scheduled Service" label-for="scheduled_service"
                                            label-cols="12">
                                            <b-input-group>
                                                <b-form-input type="text" v-model="item.scheduled_service"
                                                    placeholder="Enter scheduled service" size="sm"></b-form-input>
                                                <b-input-group-append>
                                                    <b-button size="sm" variant="outline-secondary"
                                                        @click="item.scheduled_service = ''">
                                                        <i class="fa fa-remove"></i>
                                                    </b-button>
                                                </b-input-group-append>
                                            </b-input-group>
                                        </b-form-group>
                                    </b-col>
                                    <b-col cols="12" sm="6" md="4" xl="3">
                                        <b-form-group label="GPS Code" label-for="gps_code" label-cols="12">
                                            <b-input-group>
                                                <b-form-input type="text" v-model="item.gps_code"
                                                    placeholder="Enter GPS code" size="sm"></b-form-input>
                                                <b-input-group-append>
                                                    <b-button size="sm" variant="outline-secondary"
                                                        @click="item.gps_code = ''">
                                                        <i class="fa fa-remove"></i>
                                                    </b-button>
                                                </b-input-group-append>
                                            </b-input-group>
                                        </b-form-group>
                                    </b-col>
                                    <b-col cols="12" sm="6" md="4" xl="3">
                                        <b-form-group label="IATA" label-for="iata_code" label-cols="12">
                                            <b-input-group>
                                                <b-form-input type="text" v-model="item.iata_code"
                                                    placeholder="Enter IATA code" size="sm"></b-form-input>
                                                <b-input-group-append>
                                                    <b-button size="sm" variant="outline-secondary"
                                                        @click="item.iata_code = ''">
                                                        <i class="fa fa-remove"></i>
                                                    </b-button>
                                                </b-input-group-append>
                                            </b-input-group>
                                        </b-form-group>
                                    </b-col>
                                    <b-col cols="12" sm="6" md="4" xl="3">
                                        <b-form-group label="Local Code" label-for="local_code" label-cols="12">
                                            <b-input-group>
                                                <b-form-input type="text" v-model="item.local_code"
                                                    placeholder="Enter local code" size="sm"></b-form-input>
                                                <b-input-group-append>
                                                    <b-button size="sm" variant="outline-secondary"
                                                        @click="item.local_code = ''">
                                                        <i class="fa fa-remove"></i>
                                                    </b-button>
                                                </b-input-group-append>
                                            </b-input-group>
                                        </b-form-group>
                                    </b-col>
                                    <b-col cols="12" sm="6" md="4" xl="3">
                                        <b-form-group label="Home Link" label-for="home_link" label-cols="12">
                                            <b-input-group>
                                                <b-form-input type="text" v-model="item.home_link"
                                                    placeholder="Enter home link" size="sm"></b-form-input>
                                                <b-input-group-append>
                                                    <b-button size="sm" variant="outline-secondary"
                                                        @click="item.home_link = ''">
                                                        <i class="fa fa-remove"></i>
                                                    </b-button>
                                                </b-input-group-append>
                                            </b-input-group>
                                        </b-form-group>
                                    </b-col>
                                    <b-col cols="12" sm="6" md="4" xl="3">
                                        <b-form-group label="Wikipedia Link" label-for="wikipedia_link" label-cols="12">
                                            <b-input-group>
                                                <b-form-input type="text" v-model="item.wikipedia_link"
                                                    placeholder="Enter wikipedia link" size="sm"></b-form-input>
                                                <b-input-group-append>
                                                    <b-button size="sm" variant="outline-secondary"
                                                        @click="item.wikipedia_link = ''">
                                                        <i class="fa fa-remove"></i>
                                                    </b-button>
                                                </b-input-group-append>
                                            </b-input-group>
                                        </b-form-group>
                                    </b-col>
                                    <b-col cols="12" sm="6" md="4" xl="3">
                                        <b-form-group label="Keywords" label-for="keywords" label-cols="12">
                                            <b-input-group>
                                                <b-form-input type="text" v-model="item.keywords"
                                                    placeholder="Enter keywords" size="sm"></b-form-input>
                                                <b-input-group-append>
                                                    <b-button size="sm" variant="outline-secondary"
                                                        @click="item.keywords = ''">
                                                        <i class="fa fa-remove"></i>
                                                    </b-button>
                                                </b-input-group-append>
                                            </b-input-group>
                                        </b-form-group>
                                    </b-col>
                                    <b-col cols="12" sm="6" md="4" xl="3">
                                        <b-form-group label="_ID" label-for="_id" label-cols="12">
                                            <b-input-group class="treeselect_all" style="left:25px; top:-13px">
                                                <i class="fa fa-info-circle text-black" id="_id"></i>
                                            </b-input-group>
                                            <b-tooltip target="_id" triggers="hover" placement="top">ID from source
                                                file</b-tooltip>
                                            <b-input-group>
                                                <b-form-input type="text" v-model="item._id" placeholder="Enter ID"
                                                    size="sm"></b-form-input>
                                                <b-input-group-append>
                                                    <b-button size="sm" variant="outline-secondary"
                                                        @click="item._id = ''">
                                                        <i class="fa fa-remove"></i>
                                                    </b-button>
                                                </b-input-group-append>
                                            </b-input-group>
                                        </b-form-group>
                                    </b-col>
                                </b-row>

                            </p>
                        </b-tab>
                        <b-tab v-if="idselected">
                            <template #title>
                                <i class="fa fa-history text-primary mr-1"></i> Audit
                            </template>
                            <p class="py-3 px-0">
                                <b-row>
                                    <b-col cols="12" sm="6" md="4" xl="3">
                                        <b-form-group label="Created At" label-for="created_at" label-cols="12">
                                            <b-input-group>
                                                <b-input-group-prepend>
                                                    <b-form-datepicker size="sm" v-model="item.created_at" button-only
                                                        label-help="" locale="en-GB"
                                                        :disabled="true"></b-form-datepicker>
                                                </b-input-group-prepend>
                                                <b-form-input size="sm" id="date" v-model="item.created_at" type="text"
                                                    placeholder="YYYY-MM-DD" autocomplete="off"
                                                    :disabled="true"></b-form-input>
                                                <b-input-group-append>
                                                    <b-button size="sm" variant="outline-secondary"
                                                        @click="item.created_at = null" :disabled="true">
                                                        <i class="fa fa-remove"></i>
                                                    </b-button>
                                                </b-input-group-append>
                                            </b-input-group>
                                        </b-form-group>
                                    </b-col>

                                    <b-col cols="12" sm="6" md="4" xl="3">
                                        <b-form-group label="Created By" label-for="created_by" label-cols="12">
                                            <b-input-group>
                                                <b-form-input type="text" v-model="item.created_by" placeholder=""
                                                    size="sm" :disabled="true"></b-form-input>
                                                <b-input-group-append>
                                                    <b-button size="sm" variant="outline-secondary"
                                                        @click="item.created_by = ''" :disabled="true">
                                                        <i class="fa fa-remove"></i>
                                                    </b-button>
                                                </b-input-group-append>
                                            </b-input-group>
                                        </b-form-group>
                                    </b-col>

                                    <b-col cols="12" sm="6" md="4" xl="3">
                                        <b-form-group label="Updated At" label-for="updated_at" label-cols="12">
                                            <b-input-group>
                                                <b-input-group-prepend>
                                                    <b-form-datepicker size="sm" v-model="item.updated_at" button-only
                                                        label-help="" locale="en-GB"
                                                        :disabled="true"></b-form-datepicker>
                                                </b-input-group-prepend>
                                                <b-form-input size="sm" id="date" v-model="item.updated_at" type="text"
                                                    placeholder="YYYY-MM-DD" autocomplete="off"
                                                    :disabled="true"></b-form-input>
                                                <b-input-group-append>
                                                    <b-button size="sm" variant="outline-secondary"
                                                        @click="item.updated_at = null" :disabled="true">
                                                        <i class="fa fa-remove"></i>
                                                    </b-button>
                                                </b-input-group-append>
                                            </b-input-group>
                                        </b-form-group>
                                    </b-col>

                                    <b-col cols="12" sm="6" md="4" xl="3">
                                        <b-form-group label="Updated By" label-for="updated_by" label-cols="12">
                                            <b-input-group>
                                                <b-form-input type="text" v-model="item.updated_by" placeholder=""
                                                    size="sm" :disabled="true"></b-form-input>
                                                <b-input-group-append>
                                                    <b-button size="sm" variant="outline-secondary"
                                                        @click="item.updated_by = ''" :disabled="true">
                                                        <i class="fa fa-remove"></i>
                                                    </b-button>
                                                </b-input-group-append>
                                            </b-input-group>
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                            </p>
                        </b-tab></b-tabs>

                </b-card-body>
                <b-card-footer class="nopadding mt-2">
                    <b-row no-gutters>
                        <b-col cols="auto" class="text-left mr-3">
                            <b-button squared size="sm" variant="primary" @click="saveit"
                                v-if="user.permissions.includes('setup_cabinclassairlines.admin')">
                                <i class="fa fa-check"></i>
                                Save It
                            </b-button>
                        </b-col>
                        <b-col class="text-left my-auto">
                            <div v-if="busy">
                                <i class="fa fa-spinner fa-spin text-primary"></i>
                            </div>
                            <div v-else>
                                <span v-html="message"></span>
                            </div>
                        </b-col>
                        <b-col class="text-right" cols="8">
                            <b-button squared size="sm" variant="secondary" class="mr-1" @click="discard">
                                <i class="fa fa-chevron-left pr-1"></i>
                                Back
                            </b-button>
                        </b-col>
                    </b-row>
                </b-card-footer>
            </div>
        </b-card>
    </b-overlay>
</template>

<script>
import { mapGetters } from "vuex";
import gql from "graphql-tag";

import moment from "moment";

export default {
    name: "AirportEdit",

    data() {
        return {
            busy: false,
            item: {
                id: null,
                ident: null,
                type: null,
                name: null,
                latitude_deg: null,
                longitude_deg: null,
                elevation_ft: null,
                continent: null,
                iso_country: null,
                iso_region: null,
                municipality: null,
                scheduled_service: null,
                gps_code: null,
                iata_code: null,
                local_code: null,
                home_link: null,
                wikipedia_link: null,
                keywords: null,
                _id: null,
            },
            options: {
                title: "Airports",
                icon: "fa fa-list",
            },
        };
    },
    methods: {
        async load() {
            let variables = {
                id: this.idselected,
            };
            console.log("variables", variables);
            try {
                const response = await this.$apollo.query({
                    query: gql`
                query setup_airports($id: String) {
                  setup_airports(id: $id) {
                    id
                    ident
                    type
                    name
                    latitude_deg
                    longitude_deg
                    elevation_ft
                    continent
                    iso_country
                    iso_region
                    municipality
                    scheduled_service
                    gps_code
                    iata_code   
                    local_code
                    home_link
                    wikipedia_link
                    keywords     
                    _id          
                    created_at
                    created_by
                    updated_at
                    updated_by
                  }
                }
              `,
                    variables,
                });

                if (response.data.setup_airports.length > 0) {
                    this.item = response.data.setup_airports[0];
                }
            } catch (error) {
                console.log(error);
            }
            this.busy = false;
        },
        async saveit() {
            this.busy = true;

            let variables = { rows: [this.cleanit(this.item)] };
            console.log("variables", variables);

            try {
                const response = await this.$apollo.mutate({
                    mutation: gql`
                mutation setup_airports_save($rows: [setup_airports_input]) {
                  setup_airports_save(rows: $rows) {
                    id
                    ident
                    type
                    name
                    latitude_deg
                    longitude_deg
                    elevation_ft
                    continent
                    iso_country
                    iso_region
                    municipality
                    scheduled_service
                    gps_code
                    iata_code   
                    local_code
                    home_link
                    wikipedia_link
                    keywords
                    _id               
                    created_at
                    created_by
                    updated_at
                    updated_by      
                    }
                }
              `,
                    variables,
                });
                console.log(response);
                this.message = "<span class='text-primary'>Saved it.</span>";
            } catch (error) {
                this.message = "<span class='text-danger'>" + error.message + "</span>";
            }

            this.busy = false;
        },
    },
};
</script>

<style></style>